import { groupType, DIR } from "../../constants/constants";
import { columnsConfig, columnsDefaultValues,  MPC_ROW_TYPE, LOCAL_DISTRIBUTOR_INDEX, styles } from "./constants";
import { type TExcelHeaderValue, type TExcelItem, type TExcelData } from "./types";

export const extractSubstitutionProducts = (item) => {
  switch(item.sectionType) {
    case MPC_ROW_TYPE.SUBSTITUTION_PRODUCT:
      const product = item.products[0];
      const { sectionType: itemType, title:substitutionText,  replacingQty: quantity} = item;
      const { commercialReference: partNumber,description: shortDescription, currency, price } = product.sku || {};
      return {
        itemType,
        substitutionText,
        partNumber,
        quantity,
        entityType: itemType, 
        shortDescription,
        currency ,
        price,
      };
    case MPC_ROW_TYPE.GROUP_PRODUCT:
      const products = item.products?.map(product => {
        const { quantity } = product;
        const { commercialReference, currency,description, price, configurationMasterId } = product.sku;
        return {
          itemType: item.sectionType,
          partNumber: commercialReference,
          currency,
          shortDescription: description,
          configurationId:configurationMasterId,
          quantity,
          price,
        }
      });
    return {
      itemType: item.sectionType,
      substitutionText: item.title,
      quantity: item.replacingQty,
      products,
    }
    case MPC_ROW_TYPE.SUBSTITUTION_RANGE:
        return {
          substitutionText: item.title,
          quantity: item.replacingQty,
          partNumber: item.range?.repositoryId,
          itemType: item.sectionType,
          shortDescription: item.range?.description || styles.LITERALS.EMPTY,
        }
    default:
      console.log(`Unknown substittion type: ${item.sectionType}`);
  }
}

const extractDataFromItem = (item, subsRootStore, hiveId = null) : TExcelItem => {
  const { productBarText: statusBarText, productBarColor: statusBarColor} = item;
  const weeePriceLabel = item.weeePrices?.weeePriceLabel;
  let substitutions;  
  if(item.hasStatus) {
      const sections = subsRootStore?.getSubstSectionStores(item);
      if(sections)
        substitutions = sections.map(item => 
                        extractSubstitutionProducts(item));
    }

  return { 
    itemType: !!hiveId ? MPC_ROW_TYPE.BOM_PRODUCT: MPC_ROW_TYPE.DEFAULT,
    hasStatus: item.hasStatus,
    partNumber: item.skuID,
    quantity: item.quantity,
    configurationId: item.configurationId,
    productCode: item.codification,
    shortDescription: item.commDesc,
    shippingDays: item.shippingDays,
    price: item.price,
    currency: item.currency,
    subtotal: item.subtotal,
    elNumber: item.elNumber,
    elNumberLabel: item.elNumberLabel,
    weeePriceLabel,
    statusBarColor,
    statusBarText,
    substitutions,
  };
}

export const extractExcelData = (labelsStore, cartStore, substRootStore,optionsStore, dir): TExcelData => {
  const { basketTitle, totalLabel,giftlistContactUsText: callUsText, contactSalesLabel } = labelsStore;
  const { subtotal } = cartStore;
  const {currency, isPriceEnabledOnSite, callUsURL: callUsUrl, contactSalesURL}= optionsStore;
  const direction = dir === DIR.rtl ? dir: DIR.ltr;
  const config =  direction === DIR.rtl ? columnsConfig.reverse(): columnsConfig;
  const defaultHeaders = direction === DIR.rtl ? columnsDefaultValues.reverse() : columnsDefaultValues;
  const products = cartStore.selectByGroupType.map(item => {
    switch(item.type){
      case groupType.SINGLE:
        return item.selectCards.map(card=> extractDataFromItem(card, substRootStore));
      case groupType.GROUP:
        const { 
          name, 
          quantity, 
          configurationMasterId, 
          type, 
          codification, 
          currency, 
          subtotal,
          elNumber,
          elNumberLabel,
          hiveId, 
          price 
        } = item;
        const products = item.selectCards.map(card=> extractDataFromItem(card,substRootStore,hiveId));
        return {
          itemType:type,
          name,
          quantity,
          configurationId: configurationMasterId,
          codification,
          elNumber,
          elNumberLabel,
          currency,
          subtotal, 
          price,
          hiveId,
          products,
        }
        default:
          item.type = MPC_ROW_TYPE.DEFAULT; 
          return extractDataFromItem(item,substRootStore);
    }
  });
  const { isLegalTextEnabled, isWeeePricesVisible } = optionsStore;
  
  const productWithWeeePrice = products.find(product => !!product.weeePriceLabel);
  const showDisclaimer = !isWeeePricesVisible && isLegalTextEnabled && !!labelsStore.priceTaxLabel;
  const showWeeePrice = isWeeePricesVisible && !!productWithWeeePrice?.weeePriceLabel;
  const productsWithElNumber = products.flat().filter(product => product.elNumber);
  
  const headerValues: TExcelHeaderValue[] = config.map(
    ({ key, hidden, width }, index) => {
      let header = labelsStore[key] || defaultHeaders[index];
      if (productsWithElNumber.length && index === LOCAL_DISTRIBUTOR_INDEX)
        header = productsWithElNumber[0].elNumberLabel;
      return {
        header,
        hidden,
        width,
        key
      };
    }
  );

  return {
    locale: optionsStore.locale,
    contactSalesLabel: String(contactSalesLabel),
    contactSalesURL: String(contactSalesURL),
    filename: String(basketTitle || ''),
    callUsUrl: String(callUsUrl || ''),
    totalLabel: String(totalLabel || ''),
    total: subtotal,
    currency,
    isPriceEnabledOnSite: Boolean(isPriceEnabledOnSite),
    callUsText: String(callUsText || ''),
    disclaimer: showDisclaimer? labelsStore.priceTaxLabel: null,
    weeePrice: showWeeePrice? productWithWeeePrice.weeePriceLabel: null,
    headerValues,
    products      
  }
}